export const ESTATES_TOOLBAR_ROUTES = {
  ESTATES: '/_authenticated/_sidebar-layout/estates/' as const,
  ESTATES_ME: '/_authenticated/_sidebar-layout/estates/me' as const,
  PROJECT_OBJECTS:
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects' as const,
  TENANT_ESTATES: '/_authenticated/_sidebar-layout/tenant/$tenantId/estates' as const,
} as const;

export type EstatesToolbarUrl =
  (typeof ESTATES_TOOLBAR_ROUTES)[keyof typeof ESTATES_TOOLBAR_ROUTES];
